module.exports = __webpack_public_path__ + "static/media/log-out.54051c0b.svg";